export const apiUrl = import.meta.env.VITE_API_BASE_URL;
export const razorpayKey = import.meta.env.VITE_RAZORPAY_KEY_ID;

